module.exports = ".timer {\n  font-size: 1.0em;\n  letter-spacing: -1px; }\n\n.timer span {\n  font-size: 1em; }\n"